import { Injectable } from '@angular/core';
import {ApiRequestService} from "../../shared/api-request.service";
import {UtilsService} from "../../shared/utils.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalConfigurationService {

  constructor(
    private api: ApiRequestService,
    private utils: UtilsService
  ) { }

  /**
   * Retrieves the value of a specific global setting based on the provided key.
   *
   * @param {string} key The key of the setting to retrieve.
   * @return {Promise<any>} A Promise that resolves with the value of the setting, or null if an error occurs.
   */
  async getSettingValueByKey(key: string) {
    return this.api.makeRequest('get', `v2/global-settings/${key}`)
      .then((response: any) => {
        return response;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
        return null;
      });
  }

  /**
   * Updates the value of a specific global setting based on the provided key.
   *
   * @param {string} key The key of the global setting to update.
   * @param {any} value The value of the global setting to update.
   * @return {Promise<any>} A Promise that resolves with the updated global setting, or null if an error occurs.
   */
  async updateSettingValueByKey(key: string, value: any) {
    return this.api.makeRequest('put', `v2/global-settings/${key}`, { setting_value: value })
      .then((response: any) => {
        return response;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
        return null;
      });
  }

}
